import React from "react";
import CharacterOption from "../../../model/CharacterOption";
import ImageLink from "../../../components/image-link/ImageLink";
import ContentBox from "../../../components/content-box/ContentBox";
import PageActions from "../../base/PageActions";
import useFetchResult from "../../../hooks/UseFetchResult";
import _http_service from "../../../services/HttpService";
import _image_service from "../../../services/ImageService";
import _naming_service from "../../../services/NamingService";
import '../../styles/Common.scss';
import '../../styles/Adventurers.scss';
import './AdventurersCharactersPage.scss';

interface AdventurersCharactersPageProps {
}

const AdventurersCharactersPage = (props: AdventurersCharactersPageProps) => {

    const page: PageActions = new PageActions({
        title: `Characters - Caudalglen Guild of Adventurers`,
        description: `Meet the characters of the CGA world and learn their abilities and histories!`,
        keywords: ["oc", "character", "anthropomorphic", "fantasy character", "fantasy world"],
        imgSrc: `cga/characters/aerilyn/1.png`,
        url: `cga/characters`
    });

    const [getResult, hasFetchedResult] = useFetchResult<CharacterOption[]>([] as CharacterOption[],
        async () => _http_service.getGuildCharacterOptions()
            .then(response =>
                (!response || response.length === 0) ? [] : response
            ), []);

    return page.generateMetaContent(
        <>
            <ContentBox design="scroll"
                        header="The CGA has various roles, classes, and abilities. Choose a character to learn more about them!">
                <h3 className="headline">Guild Members</h3>
                <div className="character-lineup">
                    {hasFetchedResult && getResult().filter(option => option.category === 'GUILDMEMBER')
                        .map(option =>
                            <ImageLink
                                key={`character-cga-${option.shortName}`}
                                imgSrc={_image_service.getCdnImageSrc(`cga/characters/${option.shortName}/1.png`)}
                                linkUrl={option.shortName}
                                linkName={`${_naming_service.capitalizeName(option.shortName)}`}/>
                    )}
                </div>
            </ContentBox>
        </>
    );
}

export default AdventurersCharactersPage;